import i18n from "i18n";
import { useMutation } from "@tanstack/react-query";
import { DataTieringRepositories } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
const translate = (key, options) => i18n.t(key, { ns: "enterprise_data_tiering", ...options });
const deleteSnapshot = async (indexSetId) => DataTieringRepositories.deleteFailedSnapshot(indexSetId);
const useDeleteFailedSnapshotMutation = (indexSetId) => {
  const remove = useMutation({
    mutationFn: () => deleteSnapshot(indexSetId),
    onError: (errorThrown) => {
      UserNotification.error(
        translate("notifications.snapshot_deletion_failed", { error: String(errorThrown) }),
        translate("notifications.snapshot_could_not_delete")
      );
    },
    onSuccess: () => {
      UserNotification.success(
        translate("notifications.snapshot_deleted"),
        translate("notifications.snapshot_success_title")
      );
    }
  });
  return { deleteFailedSnapshot: remove.mutateAsync };
};
export default useDeleteFailedSnapshotMutation;
